import { ContentDialog } from '@opositandopn/ui';
import classnames from 'classnames';
import { HiSparkles } from 'react-icons/hi2';

import EmptyImg from '../../../assets/images/af448e87-3b3b-4b01-8ded-cd3d0dbb1927.webp';
import { useApp, useAppActions } from '../../../state/appStore';
import { BaseComponentProps } from '../../../types/base-component.types';

import styles from './QuotaExceededPopup.module.scss';

function QuotaExceededPopup({
  className,
  testId = 'ui-quota-exceeded-popup',
}: BaseComponentProps) {
  const { showQuotaExceededPopup } = useApp();
  const { setShowQuotaExceededPopup } = useAppActions();

  return (
    <ContentDialog
      ai
      title="Tokens agotados"
      titleIcon={<HiSparkles className={styles['emoji']} />}
      open={showQuotaExceededPopup}
      onClose={() => {
        setShowQuotaExceededPopup(false);
      }}
      className={classnames(styles['main'], className)}
      testId={testId}
    >
      <div className={styles['content']}>
        <img src={EmptyImg} alt="" />
        <div className={styles['description']}>
          <h6>Has consumido tus 50 tokens mensuales.</h6>
          <span>
            Se renovarán automáticamente el próximo mes para que puedas seguir
            usando nuestra IA sin problemas
          </span>
        </div>
      </div>
    </ContentDialog>
  );
}

export { QuotaExceededPopup };
